import { gql } from '@apollo/client'

import { SHOP_CART_FRAGMENT, SHOP_FRAGMENT } from '../fragments'

export const APPLY_DISCOUNT_CODE = gql`
  mutation ApplyDiscountCode($code: String!) {
    applyDiscountCode(input: { code: $code }) {
      cart {
        ...ShopCart
      }
      shop {
        ...Shop
      }
    }
  }
  ${SHOP_CART_FRAGMENT}
  ${SHOP_FRAGMENT}
`

export const CANCEL_APPLYING_DISCOUNT_CODE = gql`
  mutation CancelApplyingDiscountCode($id: ID!) {
    cancelApplyingDiscountCode(input: { id: $id }) {
      cart {
        ...ShopCart
      }
      shop {
        ...Shop
      }
    }
  }
  ${SHOP_CART_FRAGMENT}
  ${SHOP_FRAGMENT}
`
